module.exports = __webpack_public_path__ + "img/Goin_4.f69b2387.jpg";